import React from 'react';
import { Col, Form, InputGroup } from 'react-bootstrap';

export const FormField = ({
  min,
  label,
  name,
  value,
  type = 'text',
  onChange,
  error,
  options,
  prefix,
  disabled,
  required,
  col,
  defaultValue,
}) => (
  <Form.Group as={Col} className={`${col ? `col-${col}` : 'col-lg-3 col-md-4 col-sm-6'} mb-3`}>
    <Form.Label>
      {label} {required && <span className="text-danger">*</span>}
    </Form.Label>
    {type === 'radio' ? (
      <div>
        {options.map((option, index) => (
          <>
            <Form.Check
              key={`${name}-${option}-${index}`}
              inline
              type="radio"
              id={`${name}-${option}`}
              label={option}
              name={name}
              value={option}
              defaultChecked={option === defaultValue}
              onChange={onChange}
              disabled={disabled}
              isInvalid={!!error}
            />
          </>
        ))}
      </div>
    ) : options ? (
      <Form.Select
        name={name}
        value={value}
        onChange={onChange}
        isInvalid={!!error}
        required={required}
        disabled={disabled}
      >
        <option value="">Select {label}</option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Form.Select>
    ) : prefix ? (
      <InputGroup>
        <InputGroup.Text>{prefix}</InputGroup.Text>
        <Form.Control
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          isInvalid={!!error}
          required={required}
          maxLength={type === 'tel' ? 10 : undefined}
          onInput={
            type === 'tel'
              ? (e) => {
                  e.target.value = e.target.value.replace(/\D/g, '');
                }
              : undefined
          }
        />
        <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
      </InputGroup>
    ) : (
      <Form.Control
        min={min}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        isInvalid={!!error}
        required={required}
        disabled={disabled}
        maxLength={name === 'firstName' || name === 'lastName' ? 50 : undefined}
      />
    )}
    {type !== 'radio' && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
  </Form.Group>
);
